import { type DocumentType } from "@digits-graphql/frontend/graphql-bearer"
import { FILTERABLE_DOCUMENT_TYPES } from "./constants"

function isDocumentType(documentType: string): documentType is DocumentType {
  return (FILTERABLE_DOCUMENT_TYPES as string[]).includes(documentType)
}

export function makeValidDocumentTypes(documentTypes: string[] | null) {
  if (documentTypes) {
    return documentTypes.filter((dt) => isDocumentType(dt))
  }
  return undefined
}
